import './styles.css';

import Button from '@components/button/Button';

// Base styles for various data types
export const baseStyles = {
  ul: {
    padding: '0px',
    margin: '0 0 0 25px',
    listStyle: 'none',
  },
  li: {
    minHeight: '22px',
    lineHeight: '22px',
    outline: '0px',
  },
  name: {
    color: '#abc06e',
  },
  minus: {
    color: 'red',
  },
};

// Specific styles for different data types
export const styleMap: any = {
  Object: {
    ...baseStyles,
    plus: { color: 'green' },
    collapsed: { color: '#f7c87b' },
  },
  Array: {
    ...baseStyles,
    plus: { color: 'green' },
    collapsed: { color: 'grey' },
  },
  Boolean: {
    ...baseStyles,
    value: { color: '#b1b1e2' },
  },
  String: {
    ...baseStyles,
    value: { color: '#f7c87b' },
  },
  Null: {
    ...baseStyles,
    value: { color: '#b1b1e2' },
  },
  Number: {
    ...baseStyles,
    value: { color: '#b1b1e2' },
  },
};

const buttonClass = '!w-14 !h-6 !text-white';

// Button elements for the JSON tree
export const customButtons = {
  addButtonElement: (
    <Button variant="outlined" label="Add" classOverride={buttonClass} />
  ),
  cancelButtonElement: (
    <Button variant="outlined" label="Cancel" classOverride={buttonClass} />
  ),
  editButtonElement: (
    <Button variant="outlined" label="Edit" classOverride={buttonClass} />
  ),
};
